import loader from "./loader";

window.pintrk = window.pintrk || function () {};

function insertNodeBeforeScript(node) {
    const script = document.getElementsByTagName("script")[0];
    script.parentNode.insertBefore(node, script);
}

const load = loader(() => {
    window.pintrk = function (...args) {
        window.pintrk.queue.push(Array.prototype.slice.call(args));
    };
    window.pintrk.queue = [];
    window.pintrk.version = "3.0";

    var script = document.createElement("script");
    script.async = !0;
    script.src = "https://s.pinimg.com/ct/core.js";
    insertNodeBeforeScript(script);
});

export default function () {
    load();
    window.pintrk("load", "2618393217634");
    window.pintrk("page");
    window.pintrk("track", "pagevisit");

    let img = document.createElement("img");
    img.height = "1";
    img.width = "1";
    img.style = "display:none;";
    img.alt = "";
    img.src = "https://ct.pinterest.com/v3/?event=init&tid=2618393217634&noscript=1";

    let noscript = document.createElement("noscript");
    noscript.appendChild(img);
    insertNodeBeforeScript(noscript);
}
